import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Globals } from '../globals';
import { map } from 'rxjs/operators';
import { ApiAuthService } from './api-auth.service';
import { Proveedor } from '../models/Proveedor';
import { isNullOrUndefined, isNull } from 'util';

@Injectable({
  providedIn: 'root'
})

export class ApiProcedimientosService {

  private usuario: Proveedor;
  private RFC: string;
  private headers: HttpHeaders;

  constructor(public globals: Globals, private httpApi: HttpClient, private apiAuth: ApiAuthService) {
    this.usuario = apiAuth.getTokenDecoded();

    if (isNullOrUndefined(this.usuario)) {
      this.RFC = "Publico";
    } else {
      this.RFC = this.usuario.RFC;
    }
  }

  getDatosGenerales(anio: string, idProcedimiento: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + "getDatosGenerales_E?anio=" + anio + "&idProcedimiento=" + idProcedimiento + "&usuario=" + this.RFC, {headers: this.headers})
      .pipe(map(data => data));
  }

  getArticulos(anio: string, idProcedimiento: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + "getArticulos_E?anio=" + anio + "&idProcedimiento=" + idProcedimiento + "&usuario=" + this.RFC, {headers: this.headers})
      .pipe(map(data => data));
  }

  getAnexos(iActido: string, anio: string, idProcedimiento: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + "getAnexos_E?iActido=" + iActido +"&anio=" + anio + "&idProcedimiento=" + idProcedimiento + "&usuario=" + this.RFC, {headers: this.headers})
      .pipe(map(data => data));
  }

  getListaProcs(anio: string, pantalla: number, proveedor: string, perfil: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + `obtenerListaProcs_E?anio=${ anio }&vpn_pantalla=${ pantalla }&vpn_proveedor=${ proveedor }&perfil=${ perfil }`, {headers: this.headers})
                .pipe(map(data => data));
  }

  getInformacionRfcSinToken(rfc: string) {
    debugger;
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL + `getInfoProveedor?rfc=${ rfc }`, { headers: this.headers})
                .pipe(map(data => data));
  }

  updateProcesoProveedor(anio: string, idProcedimiento: string, proveedor: string, estatus: string, comentCli?: string, comentUAA?: string,
    monto?: string, docto?: string, fecinteres?: string, fecparticipa?: string, fecprop?: string, fecdesc?: string, fecdecli?: string, fecadju?: string){

    this.getHeader();

    let httpParams = new HttpParams()
      .append("anio", anio)
      .append("idProcedimiento", idProcedimiento)
      .append("proveedor", proveedor)
      .append("estatus",estatus)
      .append("usuario", this.RFC);

    if (!isNullOrUndefined(comentCli))    {httpParams = httpParams.append("comentcli",    comentCli)}
    if (!isNullOrUndefined(comentUAA))    {httpParams = httpParams.append("comentuaa",    comentUAA)}
    if (!isNullOrUndefined(monto))        {httpParams = httpParams.append("monto",        monto)}
    if (!isNullOrUndefined(docto))        {httpParams = httpParams.append("docto",        docto)}
    if (!isNullOrUndefined(fecinteres))   {httpParams = httpParams.append("fecinteres",   fecinteres)}
    if (!isNullOrUndefined(fecparticipa)) {httpParams = httpParams.append("fecparticipa", fecparticipa)}
    if (!isNullOrUndefined(fecprop))      {httpParams = httpParams.append("fecprop",      fecprop)}
    if (!isNullOrUndefined(fecdesc))      {httpParams = httpParams.append("fecdesc",      fecdesc)}
    if (!isNullOrUndefined(fecdecli))     {httpParams = httpParams.append("fecdecli",     fecdecli)}
    if (!isNullOrUndefined(fecadju))      {httpParams = httpParams.append("fecadju",      fecadju)}

    return this.httpApi.post(this.globals.BASE_URL_PROCS + 'ABC_ProcesoProveedor_E', httpParams, {headers: this.headers})
      .pipe(map(data => data));
  }

  getDatosGralesProv(anio: string, idProcedimiento: string, proveedor: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + "getDatosGralesProv_E?anio=" + anio + "&idProcedimiento=" + idProcedimiento +
      "&proveedor=" + proveedor + "&usuario=" + this.RFC, {headers: this.headers})
      .pipe(map(data => data));
  }

  getArticulosProv(anio: string, idProcedimiento: string, proveedor: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + "getArticulosProv_E?anio=" + anio + "&idProcedimiento=" + idProcedimiento +
      "&proveedor=" + proveedor + "&usuario=" + this.RFC, {headers: this.headers})
      .pipe(map(data => data));
  }

  getPlazoFec(anio: string, idProcedimiento: string, usuario: string){
    //this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + `getPlazoFec_E?anio=${anio}&idProcedimiento=${idProcedimiento}&usuario=${usuario}`, { headers: this.headers })
                .pipe(map(data => data));
  }

  getPropuesta(anio: string, consec: string, prov: string, iactido: string){
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + `getPropuestas_E?anio=${anio}&consec=${consec}&prov=${prov}&iactido=${iactido}`, { headers: this.headers })
                .pipe(map(data => data));
  }

  getInfoObra(iActido: string, anio: string, idProcedimiento: string, tipo: string, prov: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + "getInfoObra_E?iActido=" + iActido +"&anio=" + anio + "&idProcedimiento=" + idProcedimiento + "&tipo=" + tipo + "&prov="+ prov +"&usuario=" + this.RFC, {headers: this.headers})
      .pipe(map(data => data));
  }

  private getHeader() {
    let token = this.apiAuth.getToken() !== null ? this.apiAuth.getToken().replace(/["\\]/g, '') : '';
    token = token.replace(/["\\]/g, '');
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      "Authorization": `Bearer ${token}`
    });
  }

  updateArticulosProv(partidas, fechaVigencia){
    this.getHeader();

    let httpParams = new HttpParams()
      .append("VPS_Partidas", JSON.stringify(partidas))
      .append("usuario", this.RFC)
      .append("fechaVigencia", fechaVigencia)

    return this.httpApi.post(this.globals.BASE_URL_PROCS + 'ABC_ArticulosProv_E', httpParams, {headers: this.headers})
      .pipe(map(data => data));
  }

  //Envio Propuesta de Obra
  updateEnviPropObra( anio: string, proc: string, prov: string, monto: string, correo: string) {
    this.getHeader();

    let httParams = new HttpParams()
        .append("vpn_anio", anio)
        .append("vpn_proc", proc)
        .append("vpn_prov", prov)
        .append("vpn_monto", monto)
        .append("email", correo);

    return this.httpApi.post(this.globals.BASE_URL_PROCS + `enviaPropuestaObra_E`, httParams, { headers: this.headers })
           .pipe(map(data => data));
  }

  getOrdenesCompra(idProveedor: string, idProcedimiento: string, usuario: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + `obtenerOrdenesCompra?proveedor=${ idProveedor }&idUsuario=${ usuario }&procedimiento=${ idProcedimiento }`, {headers: this.headers})
                .pipe(map(data => data));
  }

  getFacturas(idProveedor: string, anio: string, idProcedimiento: string, usuario: string) {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL_PROCS + `obtenerFacturas?proveedor=${ idProveedor }&idUsuario=${ usuario }&procedimiento=${ idProcedimiento }&anio=${ anio }`, {headers: this.headers})
                .pipe(map(data => data));
  }

  getPadronProveedores() {
    this.getHeader();
    return this.httpApi.get(this.globals.BASE_URL + `getPadronProveedores_E`, {headers: this.headers})
                .pipe(map(data => data));
  }
}
